<template>
	<div>

		<formmain ref="formmain" :windowType="windowType" :width="width" :height="height"
			:flowprogressid="flowprogressid" :loading="loading" @show="show" @hide="hide">
			<template #title>
				<div>{{extra.title?extra.title:title}}</div>
			</template>
			<template #main>
				<toolbar :mainForm="mainForm" :id="id" @buttonclick="toolbarClick" />
				<div :ref="name+'_form'" style="margin-top: 30px;"></div>
			</template>
			<template #footer>
				<vxe-button status="" content="取消" @click="hide"></vxe-button>
				<vxe-button status="primary" content="确定" @click="submit"></vxe-button>
			</template>
		</formmain>
		<!-- 		<template v-if="windowType=='modal'">
			<vxe-modal v-model="modalShow" :width="width" :height="height" show-footer destroy-on-close @show="show"
				@hide="hide" transfer :lock-scroll="false" :showHeader="showHeader" :loading="loading">
				<template #title>
					<div>{{extra.title?extra.title:title}}</div>
				</template>
				<template #default>
					
					<toolbar :mainForm="mainForm" :id="id" @buttonclick="toolbarClick" />
					<div :ref="name+'_form'" style="margin-top: 40px;"></div>
					
				</template>
				<template #footer>
					<vxe-button status="" content="取消" @click="hide"></vxe-button>
					<vxe-button status="primary" content="确定" @click="submit"></vxe-button>
				</template>
			</vxe-modal>
		</template>
		<template v-else>
			<windowmodal ref="windowmodal" :flowprogressid="flowprogressid">
				<template #title>
					<div>{{extra.title?extra.title:title}}</div>
				</template>
				<template #default>
					
					<toolbar :mainForm="mainForm" :id="id" @buttonclick="toolbarClick" />
					<div :ref="name+'_form'" style="margin-top: 20px;"></div>

				</template>
				<template #footer>
					<vxe-button status="" content="取消" @click="hide"></vxe-button>
					<vxe-button status="primary" content="确定" @click="submit"></vxe-button>
				</template>
			</windowmodal>
		</template> -->




		<vxe-table :data="exportData" style="display: none;" ref="wlnorderGoodsExportTable">
			<vxe-column field="goodscode" title="商品编码" cell-type="string"></vxe-column>
			<vxe-column field="goodsname" title="商品名称" cell-type="string"></vxe-column>
			<vxe-column field="goodemodel" title="商品规格" cell-type="string"></vxe-column>
			<vxe-column field="goodsbottom" title="库存下限" cell-type="string"></vxe-column>
			<vxe-column field="goodstop" title="库存上限" cell-type="string"></vxe-column>
		</vxe-table>

		<vxe-modal v-model="deliveryShow" @confirm="onDeliverySubmit" width="800" height="500" title="选择快递" show-footer
			transfer show-close destroy-on-close>
			<div style="padding: 10px 0;background-color: white;overflow: hidden;">
				<delivery ref="wlnorderDelivery" :weight="weight" :province="province" />
			</div>
		</vxe-modal>

		<vxe-modal v-model="printShow" width="80%" height="80%" title="报价单预览" transfer show-close destroy-on-close>
			<print :id="id" :name="name" :mainForm="mainForm" />
		</vxe-modal>

		<formwindow :formConfig="formModule" v-if="formwindowShow" @back="formBack" />

		<tool :toolname="toolname" v-if="toolname!=''" @back="toolname=''" />

	</div>
</template>

<script>
	import tool from '@/tool/index.vue'
	import formBase from '@_system/components/base/form.vue'
	import formmain from '@_system/components/base/formmain.vue'
	// import windowmodal from '@_system/components/forms/window/windowmodal.vue'
	import delivery from './lib/delivery.vue'
	import toolbar from './lib/toolbar.vue'
	import print from './lib/print.vue'
	export default {
		extends: formBase,
		name: 'wlnorderForm',
		props: {

		},
		data() {
			return {
				toolname: '',
				totalShow: false,
				formwindowShow: false,
				formModule: {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					foreingKey: {},
					extra: {},
				},
				printShow: false,
				mainForm: this,
				exportData: [],
				loading: false,
				deliveryShow: false,
				weight: 0,
				province: 0,
				coefficient: 1,
			}

		},

		watch: {

		},
		computed: {

		},
		// render() {
		// 	console.log(123)
		// 	return this.windowType == 'modal' ?
		// 		<div>
		// 				<vxe-modal v-model={this.modalShow} width={this.width} height={this.height} show-footer destroy-on-close onShow={this.show}
		// 					onHide={this.hide} transfer lock-scroll={false} showHeader={this.showHeader}>
		// 					<template v-slot:title>
		// 						<div>{this.extra.title?this.extra.title:this.title}</div>
		// 					</template>
		// 					<template v-slot:default>

		// 						<div ref={this.name+'_form'} style="margin-top: 40px;"></div>
		// 						<transition name="el-fade-in-linear">
		// 						{
		// 							this.loading &&		<div class="full flex form_loading"
		// 								style="background-color: white;z-index: 999;color: #409EFF;">
		// 								<i class="vxe-icon-refresh roll"></i>
		// 								<span>正在加载</span>
		// 							</div>
		// 						}
		// 						</transition>
		// 					</template>
		// 					<template v-slot:footer>
		// 						<vxe-button status="" content="取消" onClick={this.modalShow=false}></vxe-button>
		// 						<vxe-button status="primary" content="确定" onClick={this.submit}></vxe-button>
		// 					</template>
		// 				</vxe-modal>
		// 			</div> :
		// 		<div>
		// 				<windowmodal ref="windowmodal" title={this.extra.title?this.extra.title:this.title} flowprogressid={this.flowprogressid}>
		// 					<template v-slot:default>

		// 						<div ref={this.name+'_form'} style="margin-top: 20px;"></div>

		// 					</template>
		// 					<template v-slot:footer>
		// 						<vxe-button status="" content="取消" onClick={this.hide}></vxe-button>
		// 						<vxe-button status="primary" content="确定" onClick={this.submit}></vxe-button>
		// 					</template>
		// 				</windowmodal>
		// 			</div>
		// },
		created() {

		},
		mounted() {

		},
		methods: {

			// beforeInit(next) {
			// 	if (this.id == 0) {
			// 		this.$api.bidcoefficient.getStaffCoefficient().then((res) => {
			// 			this.coefficient = 1 + res / 100
			// 			next()
			// 		})
			// 	} else {
			// 		next()
			// 	}
			// },
			// afterGet(res) {
			// 	this.coefficient = res.bidcoefficient
			// },
			formBack(e) {
				let formname = this.formModule.name
				this.formwindowShow = false
				this.formModule = {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {},
					foreingKey: {},
				}
				if (e.type != 'cancle') {
					if (formname == 'customer') {

						let customercode = this.fApi.el('customercode')
						customercode.store.box[0].reload()
					}
				}
			},
			toolbarClick(e) {
				if (e == 'print') {
					this.printShow = true
				}
				if (e == 'delivery') {
					this.toolname = e
				}
			},
			beforeSubmit(formData, next) {
				this.verifyOrder(formData.onlinecode,next)

				// formData.bidcoefficient = this.coefficient
				// next()
			},
			beforeRender(res) {



				for (let i in res) {
					if (i == 'rategrossprofit' || i == 'discount') {
						res[i] = parseInt(res[i])
					}
				}
			},
			regestEvent(rule, fApi) {
				let customercode = fApi.el('customercode')
				customercode.store.box[0].toolbarButtonClickEvent = (e) => {
					if (e.code == 'add') {
						this.formModule = {
							name: 'customer',
							id: 0,
							controlltype: 1,
							windowName: '新建客户',
							foreingKey: {},
							extra: {}
						}
						this.formwindowShow = true
					}
				}

				let $son_wlnorder_goods = fApi.el('$son_wlnorder_goods')
				$son_wlnorder_goods.store.form = this
				$son_wlnorder_goods.gridOptions.cellStyle = ({
					row
				}) => {
					if (!row.bida) {
						return {
							backgroundColor: 'rgb(253, 226, 226)',

						}
					}
				}






			},

			toolsSubmit(e) {
				if (e.code == 'batchmodify') {
					let table = e.table
					let fullData = table.getTableData().fullData
					fullData.forEach((item) => {
						this.getTaxfreight(item, table)
					})
				}
			},
			cellStyle({
				row
			}) {
				console.log(row)
			},
			deliveryButton() {
				this.deliveryShow = true
				this.weight = this.fApi.getValue('weight')
				this.province = this.fApi.getValue('province')
			},
			onDeliverySubmit() {
				let res = this.$refs.wlnorderDelivery.submit()
				if (res) {
					this.fApi.setValue('freight', res.amount)
					this.fApi.setValue('delivery', res.name)
					this.freightChange()
				}

			},
			verifyOrder(code,next) {
				let $son_wlnorder_goods = this.fApi.el('$son_wlnorder_goods')
				let tabledata = $son_wlnorder_goods.store.table.getTableData().fullData
				this.$api[this.name].listTrades(code).then((res) => {
					let buff = []
					if (res.data.length == 0) {
						this.$message.error('暂无线上订单信息')
					} else {
						tabledata.forEach((item) => {
							let index = res.goods.findIndex((_item) => {
								return item.goodsid == _item.id
							})

							if (index === -1) {
								buff.push(item.goodscode)
							} else {
								if (item.orderprice != res.goods[index].orderprice) {
									//console.log(item.orderprice, res.goods[index].orderprice)
									buff.push(item.goodscode)
								}
							}
						})
						if (buff.length == 0) {
							next()
						} else {

							this.$VXETable.modal.alert({
								content: '商品编码：' + buff.join(',') + ' 销售单价与线上不同步',
								title: '提交错误',
								status: 'error'
							})
						}
					}
					// console.log(res)
					// console.log(tabledata)
					// console.log(buff)
					this.loading = false
				})
			},
			onlinecodeButton() {
				let code = this.fApi.getValue('onlinecode')
				if (code) {
					this.loading = true
					// this.loadHandle = this.$loading({
					// 	lock: true,
					// 	text: '请等待...',
					// 	spinner: 'el-icon-loading',
					// 	background: 'rgba(0, 0, 0, 0.3)'
					// })
					this.$api[this.name].listTrades(code).then((res) => {
						if (res.data.length == 0) {
							this.fApi.setValue('code', null)
							this.$message.error('暂无订单信息')

						} else {
							// if (res.data.sensitive_address) {
							// 	this.fApi.setValue('customeraddress', res.data.sensitive_address
							// 		.receiver_address_mask)
							// }
							let $son_wlnorder_goods = this.fApi.el('$son_wlnorder_goods')
							let province = this.fApi.el('province').labelTovalue(res.data.province)
							let city = this.fApi.el('province').labelTovalue(res.data.city)
							let district = this.fApi.el('province').labelTovalue(res.data.district)

							this.fApi.setValue('province', [province, city, district])
							let olddata = $son_wlnorder_goods.store.table.getTableData().fullData
							olddata.forEach((item) => {
								$son_wlnorder_goods.store.table.remove(item)
							})

							res.goods.forEach((item) => {

								let obj = {}
								obj.goodsid = item.id
								obj.goodscode = item.code
								obj.goodsname = item.name
								obj.goodsmodel = item.model
								obj.orderprice = item.orderprice
								obj.price = item.price
								obj.tbprice = item.tbprice
								obj.tmprice = item.tmprice
								obj.otherprice = item.otherprice
								obj.bid = item.bid
								obj.goodsunit = item.unit
								obj.goodsweight = item.weight
								obj.num = item.num
								obj.bida = item.bida
								obj.bidb = item.bidb

								$son_wlnorder_goods.store.table.insertAt(obj)
							})
							$son_wlnorder_goods.store.table.getTableData().fullData.forEach((item) => {
								this.getTaxfreight(item, $son_wlnorder_goods)
							})

							// if (this.loadHandle) {
							// 	this.loadHandle.close()
							// }
							//this.fApi.setValue(this.getItemValue(res.data[0],res.data))
						}
						this.loading = false
					})
				} else {
					if (this.loadHandle) {
						this.loadHandle.close()
					}
					this.$message.error('请填写订单编号')
				}
			},
			wlnorderGoodsImporttemplate() {
				this.$store.commit('getTemplate', 'wlnorder_goods')
			},
			discountChange() {
				let table = this.fApi.el('$son_wlnorder_goods')
				let tableData = table.getTableData().tableData
				tableData.forEach((row) => {
					this.getTaxfreight(row, table)
				})
			},
			freightChange() {
				let table = this.fApi.el('$son_wlnorder_goods')
				this.getTotalPrice(table)
				// let table = this.fApi.el('$son_wlnorder_goods')
				// let tableData = table.getTableData().tableData
				// tableData.forEach((row) => {
				// 	this.getTaxfreight(row, table)
				// })
			},
			taxChange() {
				let table = this.fApi.el('$son_wlnorder_goods')
				let tableData = table.getTableData().tableData
				tableData.forEach((row) => {
					this.getTaxfreight(row, table)
				})
			},
			tableInsert(e) {
				e.obj.goodsweight = e.data.weight
				e.obj.orderprice = e.data.tmprice
				e.obj.num = 0
				e.obj.rategrossprofit = 0
				e.obj.pretaxfreight = 0
				e.obj.taxfreight = 0
			},
			aftertabledelete(e) {
				switch (e.moduleName) {
					case 'wlnorder_collection':
						var table = e.table
						var fullData = table.getTableData().fullData
						var collection = 0
						fullData.forEach((item) => {
							if (item.amount) {
								collection += parseFloat(item.amount)
							}
						})
						this.fApi.setValue('collection', parseFloat(collection).toFixed(4))
						break;
				}
			},
			tablefieldChange(e) {
				switch (e.moduleName) {
					case 'wlnorder_collection':
						var table = e.table
						var fullData = table.getTableData().fullData
						var collection = 0
						fullData.forEach((item) => {
							if (item.amount) {
								collection += parseFloat(item.amount)
							}
						})
						this.fApi.setValue('collection', parseFloat(collection).toFixed(4))
						break;
					case 'wlnorder_goods':
						if (e.data.column.field == 'num') {
							this.numChange(e.data.row, e.table)
						}
						if (e.data.column.field == 'bida') {
							this.bidaChange(e.data.row, e.table)
						}
						if (e.data.column.field == 'orderprice') {
							this.orderpriceChange(e.data.row, e.table)
						}
						if (e.data.column.field == 'goodsweight') {
							this.goodsweightChange(e.data.row, e.table)
						}
						if (e.data.column.field == 'rategrossprofit') {
							this.rategrossprofitChange(e.data.row, e.table)
						}
						break;

				}
			},
			numChange(row, table) {
				this.getTaxfreight(row, table)
			},
			bidaChange(row, table) {
				this.getTaxfreight(row, table)
			},
			orderpriceChange(row, table) {
				this.getTaxfreight(row, table)
			},
			goodsweightChange(row, table) {

				this.getTaxfreight(row, table)
			},
			rategrossprofitChange(row, table) {
				this.getPriceByrategrossprofit(row, table)
			},
			getTaxfreight(row, table) {
				let discount = parseFloat(1 - this.fApi.getValue('discount') / 100)
				let orderprice = row.orderprice * discount
				// let pretaxfreight = (parseFloat(row.goodsweight) * parseFloat(this.fApi.getValue('freight')) + parseFloat(
				// 	row.orderprice))
				let pretaxfreight = parseFloat(orderprice)
				let taxfreight = pretaxfreight * (1 + parseFloat(this.fApi.getValue('tax')) / 100)
				if (this.fApi.getValue('tax') == 0) {
					pretaxfreight = orderprice.toFixed(4)
					taxfreight = orderprice.toFixed(4)
				}
				//row.pretaxfreight = parseFloat(pretaxfreight).toFixed(4)
				row.pretaxfreight = orderprice.toFixed(4)
				row.taxfreight = parseFloat(taxfreight).toFixed(4)
				row.amount = (parseFloat(row.taxfreight) * parseInt(row.num)).toFixed(4)
				this.$nextTick(() => {
					this.getTotalPrice(table)
					this.getTotalWeight(table)
					this.getTotalNumber(table)
					this.getRategrossprofit(row)
				})
			},
			getTotalPrice(table) {
				let discount = parseFloat(1 - this.fApi.getValue('discount') / 100)

				let pretotalPrice = 0
				let totalPrice = 0
				let totalBid = 0
				let rategrossprofit = 0
				let profit = 0
				let freight = this.fApi.getValue('freight') ? this.fApi.getValue('freight') : 0
				let tableData = table.getTableData().tableData
				tableData.forEach((row) => {
					pretotalPrice += parseFloat(row.pretaxfreight) * parseInt(row.num)
					totalPrice += parseFloat(row.taxfreight) * parseInt(row.num)
					if (row.bida) {
						totalBid += parseFloat(row.bida) * parseInt(row.num)
					}
				})
				pretotalPrice *= discount
				totalPrice *= discount
				profit = pretotalPrice - totalBid - freight



				rategrossprofit = profit / pretotalPrice * 100
				this.fApi.setValue('price', parseFloat(totalPrice).toFixed(4))
				this.fApi.setValue('pretaxprice', parseFloat(pretotalPrice).toFixed(4))
				this.fApi.setValue('bid', parseFloat(totalBid).toFixed(4))
				this.fApi.setValue('rategrossprofit', parseFloat(rategrossprofit).toFixed(2))
				this.fApi.setValue('profit', parseFloat(profit).toFixed(4))
			},
			getTotalNumber(table) {
				let totalNumber = 0;
				let tableData = table.getTableData().tableData
				tableData.forEach((row) => {
					totalNumber += row.num
				})
				this.fApi.setValue('num', totalNumber)
			},
			getTotalWeight(table) {
				let totalWeight = 0;
				let tableData = table.getTableData().tableData
				tableData.forEach((row) => {
					totalWeight += parseFloat(row.goodsweight) * parseInt(row.num)
				})
				this.fApi.setValue('weight', totalWeight)
			},
			getRategrossprofit(row) {
				if (row.bida) {
					let discount = parseFloat(1 - this.fApi.getValue('discount') / 100)
					let orderprice = row.orderprice * discount
					let rategrossprofit = (parseFloat(orderprice) - parseFloat(row.bida * this.coefficient)) /
						parseFloat(orderprice) * 100
					row.rategrossprofit = rategrossprofit.toFixed(2)
				} else {
					row.rategrossprofit = null
				}


			},
			getPriceByrategrossprofit(row, table) {
				if (row.bida) {
					let discount = parseFloat(1 - this.fApi.getValue('discount') / 100)
					let orderprice = parseFloat(row.bida) / (1 - parseFloat(row.rategrossprofit) / 100) / parseFloat(
						discount)
					row.orderprice = orderprice.toFixed(2)
					this.getTaxfreight(row, table)
				}


			},


		},
		components: {
			// windowmodal,
			formmain,
			delivery,
			toolbar,
			print,
			tool
		}
	}
</script>
